import { Callout } from 'zudoku/components';
import { useAuth } from 'zudoku/hooks';

/**
 * Shows a callout that either tells people to sign up for an API key, or
 * directs them to the API key page, depending on whether they're logged in.
 * Intended to be shown at the top of the intro page.
 */
export function SignupOrKeys() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <Callout type="tip">
        <a href="/settings/api-keys">Click here</a> to see your API key and
        start building.
      </Callout>
    );
  } else {
    return (
      <Callout type="info">
        👋 <a href="https://docs.rewiringamerica.org/signin">Sign-up</a> to
        receive an API key and start building.
      </Callout>
    );
  }
}
